<!--eslint-disable-->
<template>
    <el-container>
        <el-header class="header" style="height:100px">
            <span>Data de referência: </span>
            <el-date-picker class="date-picker" v-model="chosenDate" type="date" format="dd/MM/yyyy" @change="updateFilesForRefDate"></el-date-picker>
            <el-button class="download-button" @click="gerarXMLAnexos" type="primary">Download consolidado</el-button>
            <p style="font-size:15px"> Emails enviados para: <b>movimentacoes@mail.leblonfund.com.br</b> </p>
            <el-dialog :visible.sync="dialogAttachmentVisible">
                <template slot="title">
                    <span class="main-title"> {{ attachmentView.subject }} </span></br>
                    <div class="big-content"> 
                        <span class="title-detail"> {{ attachmentView.name }} </span>
                    </div>
                </template>
                <div class="big-content">
                    <span v-for="content in attachmentView.content"> {{ content }} </br></span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogAttachmentVisible = false">Fechar</el-button>
                    <el-button type="primary" @click="copyToClipboard(attachmentView.attachment)">Copiar</el-button>
                </span>
            </el-dialog>
        </el-header>
        <el-main class="main">
            <div>
                <div class="table-principal">
                    <el-table
                        v-loading="loading"
                        :data="tableData"
                        border
                        size="mini"
                        width="50%"
                        stripe>
                        <template slot="empty">
                            <span>Os anexos recebidos em movimentacoes@mail.leblonfund.com.br aparecem aqui.</span>
                        </template>
                        <el-table-column
                            type="index"
                            width="35">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            width="35">
                            <template slot="header">
                                <el-checkbox @change="checkAllChange"></el-checkbox>
                            </template>
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.status"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="subject"
                            label="Assunto"
                            min-width="40">
                            <template slot-scope="scope">
                                <div class="big-content">
                                    <span @click="visualizarAttachment(scope)">{{ scope.row.subject }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="sender"
                            label="Remetente"
                            min-width="20">
                            <template slot-scope="scope">
                                <div class="big-content">
                                    <span @click="visualizarAttachment(scope)">{{ scope.row.sender }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="attachment_name"
                            label="Nome do Anexo"
                            min-width="40">
                            <template slot-scope="scope">
                                <div class="big-content">
                                    <span @click="visualizarAttachment(scope)">{{ scope.row.attachment_name.slice(1, scope.row.attachment_name.length - 1) }}</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import format from 'xml-formatter'
import regex from '@/services/regex'

const db = fb.db

export default {
    data() {
        return {
            loading: true,
            refDate: null,
            chosenDate: new Date(),
            table: null,
            dialogVisible: false,
            form: {
                cotistas: ''
            },
            checkAll: false,
            dialogAttachmentVisible: false,
            attachmentView: {
                subject: '',
                name: '',
                content: [],
                attachment: ''
            },
            movFile: {
                name: '',
                content: []
            },
            movFilesTable: [],
            file: Object,
            fileListRetornoMovimentacoes: [],
        }
    },
    components: {
        NewEditableColumn
    },
    methods: {
        async updateFilesForRefDate() {
            db.collection('distAttachments')
                .where('timestamp', '<=', this.fimDia())
                .where('timestamp', '>=', this.inicioDia())
                .orderBy('timestamp', 'desc')
                .onSnapshot(
                    q => {
                        let auxTable = []
                        let date;
                        q.forEach(doc => {
                            date = doc.data().timestamp
                            auxTable.push({
                                status: false,
                                timestamp: new Date(doc.data().timestamp.seconds * 1000).toLocaleDateString("pt-BR"),
                                subject: doc.data().subject,
                                sender: doc.data().sender,
                                attachment_name: doc.data().attachment_name,
                                attachment: doc.data().attachment,
                                id: doc.id
                            })
                        })
                        this.table = auxTable
                        this.refDate = date
                        this.chosenDate = new Date(date.seconds * 1000)
                })
                
            db.collection('movFiles')
                .where('clientXML.timestamp', '<=', this.fimDia())
                .where('clientXML.timestamp', '>=', this.inicioDia())
                .orderBy('clientXML.timestamp', 'desc')
                .onSnapshot(
                    q => {
                        let auxTable = []
                        q.forEach(doc => {
                            
                            let retornoXML = doc.data().retornoXML
                            let readyMovCsv = doc.data().readyMovCSV
                            
                            auxTable.push({
                                data: new Date(doc.data().clientXML.timestamp.seconds * 1000).toLocaleString("pt-BR"),
                                retorno: !!retornoXML ? "OK" : "",
                                id: doc.id,
                                readyMovCSV: !!readyMovCsv ? true : false
                            })
                        })
                        this.movFilesTable = auxTable
                })
                
            await this.updateReturnMovFilesFromDb()
        },
        checkAllChange() {
            this.table.forEach(row => {
                row.status = !this.checkAll
            })
            this.checkAll = !this.checkAll
        },
        async onHttpRequestRetornoXML(file, filelist) {
            let blob = new Blob([file.file])
            let text = await blob.text()

            const matchNovos = text.match(regex.novoCotista)
            
            let arr = []
            
            matchNovos.forEach(str => {
                let aux = str.match(regex.brackets)
                arr.push({cotista: aux[1].replace("[",""), conta: aux[0].replace("[","")})
            })
            
            const matchCadastrados = text.match(regex.cotistaCadastrado)
            
            matchCadastrados.forEach(str => {
                let aux = str.match(regex.brackets)
                arr.push({cotista: aux[0].replace("[",""), conta: aux[1].replace("[","")})
            })
            
            let saveRetornoCadastroCotista = firebase.functions().httpsCallable('saveRetornoCadastroCotista');
            try {
                let result = await saveRetornoCadastroCotista({retornoXML: text, id: file.data.id})
                this.$root.$emit('showError', result.data.result, 'success')
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
            
        },
        async downloadMovCsv(scope) {
            await this.getFiles("movFiles", scope.row.id)
        },
        async getFiles(base, id) {
            let getCsvFiles = firebase.functions().httpsCallable('getCsvFiles')
            try{
                let csvFiles = await getCsvFiles({base: base, id: id})
                let csv = csvFiles.data.csv.replace(/undefined/g, '')

                const url = window.URL.createObjectURL(new Blob([csv]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', "LEBLON EQUITIES_BNY MELLON SERVIÇOS.txt")
                document.body.appendChild(link)
                link.click()
            } catch (err) {
                this.$root.$emit('showError', 'Erro ao exportar a base.', 'error')
            }
        },
        async gerarXMLAnexos() {
            // Pegar do banco o cadastro de distribuidoras

            let requestResult = await this.getXmlNewClientTemplate()
            let cadastroDistribuidoras = requestResult.data.result
            
            // Processar emails selecionados pegando os dados necessários dos anexos

            let clients = []
            let attachmentIds = []
            let movFilesClients = []
            
            this.table.forEach(doc => {
                if(doc.status == true) {
                    
                    attachmentIds.push(doc.id)
                    
                    let rows = doc.attachment.split('\n')
                    let headersRaw = rows[0].split(';')
                    let headers = headersRaw.map(header => {
                        if(header == "ORDEM_ADM") return "ORDEM ADM"
                        if(header == "CPF_CNPJ") return "CNPJ BTG"
                        if(header == "RESULTADO ") return "RESULTADO"
                        return header
                    })
                    
                    rows.forEach( (row, index) => {
                        
                        let client = {}

                        if(index != 0) {
                            if (!(row == null || row.trim() === '')) {
                                let values = row.split(';')

                                for(let i = 0; i < headers.length; i++) {
                                    let value = values[i] || ""
                                    if(headers[i] == "CNPJ BTG") {
                                        if(values[i].length <= 14 ) {
                                            value = values[i].replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
                                        }
                                    }
                                    client[headers[i]] = value.toString()
                                }
                                movFilesClients.push(client)
                                clients.push({
                                    CNPJDistribuidor: client["CNPJ BTG"].replace(/\.|-|\//g,''),
                                    nome: client["NOME"]
                                })
                            }
                        }
                    })
                }
            })
            
            // Gerar um erro caso nenhum email tenha sido selecionado (ou os selecionados não tenham nenhuma movimentação)
            
            let clientsUnique = [... new Set(clients)]
            
            if(clientsUnique.length == 0) {
                this.$root.$emit('showError', 'Nenhum e-mail selecionado.', 'error')
                return
            }
            
            // Gerar erro caso alguma distribuidora nos arquivo não esteja no cadastro
            
            let distributorsNotFound = []
            
            clientsUnique.filter(client => {
                let distributorMatch = cadastroDistribuidoras.filter(cadastro => {
                    return client.CNPJDistribuidor == cadastro.CNPJDistribuidor
                })
                if (distributorMatch.length == 0) distributorsNotFound.push(client.CNPJDistribuidor)
            })
            
            let distributorNotFoundUnique = [... new Set(distributorsNotFound)]
            
            if(distributorNotFoundUnique.length > 0) {
                let errorMsg = "Não foram encontrados o(s) distribuidor(es): " + distributorNotFoundUnique.join(', ')
                this.$root.$emit('showError', errorMsg, 'error')
                return
            }
            
            let movFiles = {
                attachments: attachmentIds,
                clients: movFilesClients,
            }
            
            let saveMovFiles = firebase.functions().httpsCallable('saveMovFiles')

            try {
                
                let result = await saveMovFiles(movFiles)
                this.$root.$emit('showError', result.data.result, 'success')
                
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
                return
            }

            let file = headers.join(';') + '\n'
            movFilesClients.map(client => {
                headers.map(header => {
                    file += `${client[header]};`
                })
                file = file.substring(0, file.length() - 1)
                file += '\n'
            })
            file = file.substring(0, file.length() - 1)
            
            try {
                const url = window.URL.createObjectURL(new Blob([format(file)]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', "Distribuidores " + this.timestampToISOString(this.refDate) +'.txt')
                document.body.appendChild(link)
                link.click()
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
            
        },
        async getXmlNewClientTemplate() {
            let getTemplate = firebase.functions().httpsCallable('getXmlNewClientTemplate')
            try {
                var template = await getTemplate()
                return template
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        visualizarAttachment(scope) {
            this.attachmentView.content = []
            this.attachmentView.attachment = scope.row["attachment"]
            this.attachmentView.subject = scope.row["subject"]
            this.attachmentView.name = scope.row["attachment_name"].slice(1, scope.row["attachment_name"].length-1)
            let rows = scope.row["attachment"].split('\n')
            for(let i=0; i < Math.min(5, rows.length); i++) {
                this.attachmentView.content.push(rows[i])
            }
            this.dialogAttachmentVisible = true
        },
        fimDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        },
        inicioDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        },
        timestampToISOString(timestamp) {
            return new Date(timestamp.seconds * 1000).toISOString().split('T')[0]
        },
        copyToClipboard(textToCopy) {
            let textarea = document.createElement('textarea')
            textarea.value = textToCopy
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
        },
        async updateReturnMovFilesFromDb() {
            const inicioDiaRefDate = (new Date(this.chosenDate.setHours(0,0,0,0))).getTime()
            const finalDiaRefDate = (new Date(this.chosenDate.setHours(23,59,59,999))).getTime()
            let movReturnFiles = (await db.collection('movReturnFiles')
            .where('_refDate', '>=', inicioDiaRefDate)
            .where('_refDate', '<=', finalDiaRefDate)
            .get()).docs
            let fileListRetornoMovimentacoesAux = []
            movReturnFiles.forEach((doc) => {
                let name = doc.data().fileName
                let fileIdFirebase = doc.id
                let file = doc.data().content
                let textParsedLines = file.split("\n")
                let textAsArray = textParsedLines.map((line) => {
                    return line.split("\t")
                })
                fileListRetornoMovimentacoesAux.push({fileData: textAsArray, name, storageFile: false, fileIdFirebase})
            })
            this.fileListRetornoMovimentacoes = fileListRetornoMovimentacoesAux
        }
    },
    computed: {
        tableData() {
            return this.table
        },
        tableMovFiles() {
            return this.movFilesTable
        }
    },
    async created() {
        this.loading = true
        db.collection('distAttachments')
            .where('timestamp', '<=', this.fimDia())
            .where('timestamp', '>=', this.inicioDia())
            .orderBy('timestamp', 'desc')
            .onSnapshot(
                q => {
                    let auxTable = []
                    let date;
                    q.forEach(doc => {
                        date = doc.data().timestamp
                        auxTable.push({
                            status: false,
                            timestamp: new Date(doc.data().timestamp.seconds * 1000).toLocaleDateString("pt-BR"),
                            subject: doc.data().subject,
                            sender: doc.data().sender,
                            attachment_name: doc.data().attachment_name,
                            attachment: doc.data().attachment,
                            id: doc.id
                        })
                    })
                    this.table = auxTable
                    this.refDate = date
                    this.chosenDate = new Date(date.seconds * 1000)
            })
                
        db.collection('movFiles')
            .where('clientXML.timestamp', '<=', this.fimDia())
            .where('clientXML.timestamp', '>=', this.inicioDia())
            .orderBy('clientXML.timestamp', 'desc')
            .onSnapshot(
                q => {
                    let auxTable = []
                    q.forEach(doc => {
                        
                        let retornoXML = doc.data().retornoXML
                        let readyMovCsv = doc.data().readyMovCSV
                        
                        auxTable.push({
                            data: new Date(doc.data().clientXML.timestamp.seconds * 1000).toLocaleString("pt-BR"),
                            retorno: !!retornoXML ? "OK" : "",
                            id: doc.id,
                            readyMovCSV: !!readyMovCsv ? true : false
                        })
                    })
                    this.movFilesTable = auxTable
            })
                
        this.updateReturnMovFilesFromDb()
    
        this.loading = false
    },
}
</script>

<style scoped>
.table-manual {
    position: relative;
    margin-top: 10px;
}
.el-input .el-input__inner {
    color: red;
}
.big-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.adicionar-linha {
    float: right;
    margin-bottom: 10px;
}
.download-button {
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.manual {
    width: 400px;
}
.retorno {
    width: 600px;
}
.distributor {
    width: 1500px;
}
.el-dialog .main-title {
    font-weight: bold;
    font-size: 22px;
}
.el-dialog .title-detail {
    font-style: italic;
    font-size: 18px;
}
.manual-content {
    max-width: 400px;
}
.retorno-content {
    max-width: 600px;
}
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
    height: 23px;
}
.date-picker >>> input{
    color: red;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 5px;
}
.header-manual {
    font-family: Calibri;
    color: #606266;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.save-table {
    float: right;
    width: 160px;
}
.header-details {
    text-align: center;
}
.el-table .cell {
    word-wrap: break-word;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.el-main.main {
    padding: 0 10px;
}
.el-footer {
    margin-top: 20px;
    padding: 0;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
.detail-date {
    font-style: italic;
    font-size: 15px;
    float: right;
}
</style>